<div class="showcase-grid">
  <div class="showcase-row" data-showcase-id="cs-grid">
    <cs-label>cs-grid / cs-grid-row / cs-grid-col</cs-label>
    <cs-grid>
      <cs-grid-row>
        <cs-grid-col>Column A</cs-grid-col>
        <cs-grid-col>Column B</cs-grid-col>
        <cs-grid-col>Column C</cs-grid-col>
      </cs-grid-row>
    </cs-grid>
  </div>

  <div class="showcase-row" data-showcase-id="cs-item-group">
    <cs-label>cs-item-group</cs-label>
    <cs-item-group [title]="'Group Title' | untranslated" small>
      <cs-item><cs-label>First item</cs-label></cs-item>
      <cs-item><cs-label>Second item</cs-label></cs-item>
    </cs-item-group>
  </div>

  <div class="showcase-row" data-showcase-id="cs-form-field">
    <cs-label>cs-form-field</cs-label>
    <cs-form-field [label]="'Name' | untranslated">
      <cs-input [value]="sampleText" (valueChange)="sampleTextChange.emit($event)" [placeholder]="'Your name' | untranslated"></cs-input>
    </cs-form-field>
  </div>

  <div class="showcase-row" data-showcase-id="cs-card-title">
    <cs-label>cs-card with cs-card-title</cs-label>
    <cs-card>
      <cs-card-title>Card Title</cs-card-title>
      <cs-card-content>
        <div class="showcase-padded">Card body text.</div>
      </cs-card-content>
    </cs-card>
  </div>

  <div class="showcase-row" data-showcase-id="cs-tab-content">
    <cs-label>cs-tab-content-container / cs-tab-content, switched by a cs-segment</cs-label>
    <cs-segment [(selection)]="showcaseTab">
      <cs-segment-button value="first">First</cs-segment-button>
      <cs-segment-button value="second">Second</cs-segment-button>
    </cs-segment>
    <!-- the panes are absolutely positioned inside the container, so it needs a height of its own -->
    <div class="showcase-tab-box">
      <cs-tab-content-container [selection]="showcaseTab">
        <cs-tab-content value="first"><div class="showcase-padded">Content of the first tab.</div></cs-tab-content>
        <cs-tab-content value="second"><div class="showcase-padded">Content of the second tab.</div></cs-tab-content>
      </cs-tab-content-container>
    </div>
  </div>

  <div class="showcase-row" data-showcase-id="cs-fab">
    <cs-label>cs-fab / cs-fab-button (tap the round button)</cs-label>
    <div class="showcase-box">
      <cs-fab icon="add">
        <cs-fab-button icon="barcode" [label]="'Scan' | untranslated"></cs-fab-button>
        <cs-fab-button icon="edit" [label]="'Add Manually' | untranslated"></cs-fab-button>
      </cs-fab>
    </div>
  </div>
</div>
